import "@/index.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { PageSpinner } from "@/components/Skeletons";

const Landing = lazy(() => import("@/pages/Landing"));
const Login = lazy(() => import("@/pages/Login"));
const Register = lazy(() => import("@/pages/Register"));
const DashboardHome = lazy(() => import("@/pages/DashboardHome"));
const Contracts = lazy(() => import("@/pages/Contracts"));
const ContractDetail = lazy(() => import("@/pages/ContractDetail"));
const Compliance = lazy(() => import("@/pages/Compliance"));
const Risk = lazy(() => import("@/pages/Risk"));
const Vault = lazy(() => import("@/pages/Vault"));
const Assistant = lazy(() => import("@/pages/Assistant"));
const Repository = lazy(() => import("@/pages/Repository"));
const Billing = lazy(() => import("@/pages/Billing"));
const DashboardLayout = lazy(() => import("@/components/DashboardLayout"));

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <PageSpinner label="Verifying session…" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <Suspense fallback={<PageSpinner />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/app"
              element={
                <Protected>
                  <DashboardLayout />
                </Protected>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="contracts" element={<Contracts />} />
              <Route path="contracts/:id" element={<ContractDetail />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="risk" element={<Risk />} />
              <Route path="vault" element={<Vault />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="repository" element={<Repository />} />
              <Route path="billing" element={<Billing />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}
